import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

export interface AiSpeakingTopic {
  image: string;
  imageContent?: string;
  openingLine: string;
  description: string;
}

export interface AnalyzeImageResult {
  content: string;
}

export interface AiSpeakingTopicsRecord {
  id: number;
  bookId: number;
  topics: AiSpeakingTopic[];
  createdAt?: string;
  updatedAt?: string;
}

/**
 * AI 口语话题 API（后端模块 AiSpeakingTopicsManage，前缀 ai-speaking-topics）。
 */
@Injectable({
  providedIn: 'root'
})
export class AiSpeakingTopicsService extends BaseService {
  private readonly base = '/ai-speaking-topics';

  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
  }

  getTopicsByBook(bookId: number | string) {
    return this.get(`${this.base}/book/${bookId}`);
  }

  /** 按 bookId 幂等保存：不存在则创建，已存在则全量更新 topics */
  saveTopics(data: { bookId: number; topics: AiSpeakingTopic[] }) {
    return this.post(this.base, data);
  }

  deleteTopics(id: number | string) {
    return this.remove(`${this.base}/${id}`);
  }

  analyzeImage(imageUrl: string) {
    return this.post(`${this.base}/analyze-image`, { imageUrl }) as Promise<AnalyzeImageResult>;
  }
}
